import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllDistricts,
  onCreateDistrict,
  onDeleteDistrict,
  onGetDistrict,
  onUpdateDistrict,
} from '../../../app/modules/base-definitions/components/districts/core/_requests'
import {
  onGetCountries,
  onGetProvincesByCountryId,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface DistrictState {
  districts: any
  district: any
  countries: any
  provinces: any
  isLoading: boolean
}
const initialState = {
  districts: [],
  district: null,
  countries: [],
  provinces: [],
  isLoading: true,
} as DistrictState

export const fetchCountries = createAsyncThunk('district/fetchCountries', async () => {
  const data: any = await onGetCountries()
  return data.data.result
})

export const fetchProvinces = createAsyncThunk('district/fetchProvinces', async (param: any) => {
  const data: any = await onGetProvincesByCountryId(param)
  return data.data.result
})

export const fetchDistricts = createAsyncThunk('district/fetchDistricts', async (param: any) => {
  const data: any = await onGetPagedAllDistricts(param)
  return data.data.result
})

export const fetchDistrict = createAsyncThunk('district/fetchDistrict', async (param: any) => {
  const data: any = await onGetDistrict(param)
  return data.data.result
})

export const updateDistrict = createAsyncThunk('district/updateDistrict', async (param: any) => {
  const data: any = await onUpdateDistrict(param)
  return data.data
})

export const createDistrict = createAsyncThunk('district/createDistrict', async (param: any) => {
  const data: any = await onCreateDistrict(param)
  return data.data
})

export const deleteDistrict = createAsyncThunk('district/deleteDistrict', async (param: any) => {
  const data: any = await onDeleteDistrict(param)
  return data.data
})

const districtSlice = createSlice({
  name: 'district',
  initialState,
  reducers: {
    clearDistricts: (state) => {
      state.districts = []
    },
    clearDistrict: (state) => {
      state.district = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDistricts.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchDistricts.fulfilled, (state: any, action) => {
      state.districts = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchDistricts.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchDistrict.fulfilled, (state: any, action) => {
      state.district = action.payload
    })
    builder.addCase(fetchCountries.fulfilled, (state: any, action) => {
      state.countries = action.payload.items
    })
    builder.addCase(fetchProvinces.fulfilled, (state: any, action) => {
      state.provinces = action.payload.items
    })
  },
})

export const {clearDistricts, clearDistrict, activateLoading} = districtSlice.actions

export default districtSlice.reducer
